import { Notifications } from '@factorin/domain';

import { get, list, withUrl, ItemRequest } from '../rest';


const noticeOfCessionPart = withUrl('noticeofcession');

export const noticeOfCession = {
    ...list<Notifications.Notice>(noticeOfCessionPart()),
    getByRegister: get<ItemRequest, Notifications.Notice>(
        ({ id }) => noticeOfCessionPart({
            path: 'byregister',
            query: {
                registerUid: id,
            },
        }),
    ),
};
